/* @jsxImportSource react */

import { type EnergyEfficiencyFlagProps } from '@packages/shared/src/ui/EnergyEfficiencyFlag/EnergyEfficiencyFlag';
import { type TireEfficiencyFlagSpecificProps } from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import { type Datasheet, ProductCardV2DatasheetLink } from './ProductCardV2.DatasheetLink';
import type { EfficiencyFlagOverlay } from '../EfficiencyFlags/components/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog.client';
import { EfficiencyFlagOverlayDialog } from '../EfficiencyFlags/components/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog.client';
import { EnergyEfficiencyFlagLocalized } from '../EfficiencyFlags/components/EnergyEfficiencyFlagLocalized/EnergyEfficiencyFlagLocalized.client';
import { TireEfficiencyFlagLocalized } from '../EfficiencyFlags/components/TireEfficiencyFlagLocalized/TireEfficiencyFlagLocalized.client';

export type ProductCardV2EnergyEfficiencyFlagsLegacyProps = {
  flags: ReadonlyArray<
    (EnergyEfficiencyFlagProps | TireEfficiencyFlagSpecificProps) & {
      overlay?: EfficiencyFlagOverlay;
    }
  >;
  datasheets: readonly Datasheet[];
};

export const ProductCardV2EnergyEfficiencyFlagsLegacy = ({
  flags,
  datasheets,
}: ProductCardV2EnergyEfficiencyFlagsLegacyProps) => (
  <div className="flex gap-1">
    <div className="flex flex-col flex-wrap items-start gap-1">
      {flags.map(({ overlay, ...flagProps }, index) => (
        <EfficiencyFlagOverlayDialog key={overlay?.title ?? index} overlay={overlay}>
          {!('type' in flagProps) && <EnergyEfficiencyFlagLocalized {...flagProps} />}
          {'type' in flagProps && <TireEfficiencyFlagLocalized {...flagProps} />}
        </EfficiencyFlagOverlayDialog>
      ))}
    </div>
    <div className="flex flex-col gap-1">
      {datasheets.map((datasheet, index) => (
        <ProductCardV2DatasheetLink key={datasheet.url ?? index} datasheet={datasheet} />
      ))}
    </div>
  </div>
);
